import DOMPurify from "dompurify";
import { getSettingDefinitions } from "../api/settings/getSettingDefinitions";
import { isAppTypeIframe } from "../getAppType";
import { lp } from "../utils/logPrefix";
import { CvpSettings } from "./CvpSettings";

// remove scrips etc, since some of the settings end up in the DOM

export const sanitizeString = (s: string) => {
  if (s === null || s === undefined) return s;

  return DOMPurify.sanitize(s);
};

export const sanitizeSettings = (settings: CvpSettings): CvpSettings => {
  const settingDefinitions = getSettingDefinitions(isAppTypeIframe());

  const sanitized: CvpSettings = Object.entries(settingDefinitions).reduce(
    (acc, [settingName, definition]) => {
      if (definition.type === "string") {
        acc[settingName] = sanitizeString(settings[settingName]);
      } else {
        acc[settingName] = settings[settingName];
      }
      return acc;
    },
    {} as CvpSettings
  );

  Object.keys(sanitized).forEach((key) => {
    if (settings[key] !== sanitized[key]) {
      console.error(lp("Sanitation of a setting caused it to change"), {
        key,
        setting: settings[key],
        sanitized: sanitized[key],
      });
    }
  });

  // let through translation preview settings
  Object.entries(settings).forEach(([key, value]) => {
    const isTranslationPreview =
      !!value?.idText && !!value?.systemText && !settingDefinitions[key];

    if (isTranslationPreview) {
      sanitized[key] = value;
    }
  });

  return sanitized;
};
